import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { DashboardHelpers } from 'utils';
import { makeStyles, Typography } from '@material-ui/core';
import { red } from '@mui/material/colors';

import _ from 'lodash';
import { FormHelperText } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  helperText: { fontSize: 12, color: red[600], paddingLeft: 8 },
}));

const PropertyDropdown = ({
  setSelectedProperty,
  selectedProperty,
  properties,
  selectedOrganization,
  required,
  helperText,
}) => {
  const classes = useStyles();

  const { t } = useTranslation();
  let relevantProps = [
    {
      id: DashboardHelpers.StatusCodes.NoPropertySelected,
      name: properties?.length > 0 ? t('none_selected') : t('none'),
    },
  ];

  if (selectedOrganization?.id !== DashboardHelpers.StatusCodes.NoOrganizationSelected) {
    relevantProps = relevantProps.concat(
      _.filter(properties, (property) => property.organization_id === selectedOrganization?.id)
    );
  } else {
    relevantProps = relevantProps.concat(...properties);
  }
  const propertyLabel = required ? t('property') + ' *' : t('property');
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2" gutterBottom component="div" justifySelf="flex-start">
        {propertyLabel}
      </Typography>
      <MenuWithId
        placeholder="Property"
        menuItems={relevantProps}
        selectedItem={selectedProperty?.name}
        selectItem={(item) => {
          setSelectedProperty(item);
        }}
        inputProps={{
          maxLength: 24,
        }}
        size="normal"
      />
      <FormHelperText className={classes.helperText}>{helperText}</FormHelperText>
    </Grid>
  );
};

PropertyDropdown.propTypes = {
  setSelectedProperty: PropTypes.func.isRequired,
  selectedProperty: PropTypes.object,
  properties: PropTypes.array,
  selectedOrganization: PropTypes.object,
  required: PropTypes.bool,
  helperText: PropTypes.string,
};

PropertyDropdown.defaultProps = {
  selectedProperty: undefined,
  properties: [],
  selectedOrganization: undefined,
  required: false,
  helperText: '',
};

export default PropertyDropdown;
